import { PureComponent } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import $ from 'jquery';

class ScrollToTop extends PureComponent<RouteComponentProps<any>> {
  componentDidUpdate(prevProps: RouteComponentProps<any>) {
    if ((this.props).location.pathname !== prevProps.location.pathname) {
      $(window).scrollTop(0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);

